<div class="container-fluid">
  <div class="row mb-2">
    <h3>{{ data.bankName }} - Extrato</h3>
  </div>

  <div class="row mb-2">
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 table">
      <ng-container matColumnDef="column1">
        <th mat-header-cell *matHeaderCellDef>Coluna 1</th>
        <td mat-cell *matCellDef="let element">{{ element.column1 }}</td>
      </ng-container>
      <ng-container matColumnDef="column2">
        <th mat-header-cell *matHeaderCellDef>Coluna 2</th>
        <td mat-cell *matCellDef="let element">{{ element.column2 }}</td>
      </ng-container>
      <ng-container matColumnDef="column3">
        <th mat-header-cell *matHeaderCellDef>Coluna 3</th>
        <td mat-cell *matCellDef="let element">{{ element.column3 }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        matRipple
        *matRowDef="let row; columns: displayedColumns"
      ></tr>
    </table>
  </div>
</div>
